module.exports = __webpack_public_path__ + "img/Setting3.7295d186.svg";